import React from "react";

import { Access } from "common";

// components
import { Page, Breadcrumbs, Navigation } from "components";

function Main() {
  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "Relatórios", to: "/reports" },
    { name: "Validação Contábil", to: "" },
  ]

  const navigation = [
    {
      name: "Vouchers Utilizados",
      to: "/report/accounting-validation/used",
      icon: null,
      hidden: !Access.hasPermissions("accounting-validation"),
    },
    {
      name: "Vouchers Ativados",
      to: "/report/accounting-validation/activated",
      icon: null,
      hidden: !Access.hasPermissions("accounting-validation"),
    },
  ];

  return (
    <Page>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <Navigation items={navigation} />
    </Page>
  );
}

export default Main;
